






























































import { Component, Prop, PropSync, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn,
  DataTable
} from '@/components/molecules/DataTable'
import { systemCodeApi, SystemCodeWithKey } from '@/api'
import { orderBy } from 'lodash'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import {
  AlertCodeALC00007,
  MaskPattern,
  SortOrder,
  UserDetailStateInfo
} from '@/types'
import { alertStore } from '@/utils/store-accessor'
import { AlertFactory } from '@/factory'

const COLS: Col[] = [
  {
    width: 40,
    items: [
      {
        name: 'contact',
        align: 'center',
        headerText: '連絡'
      }
    ]
  },
  {
    width: 40,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: 260,
    items: [
      {
        name: 'number',
        headerText: '電話番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 160,
    items: [
      {
        name: 'type',
        headerText: '電話区分',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    items: [
      {
        name: 'remove',
        align: 'center'
      }
    ]
  }
]

export interface UserPhoneTableItem {
  id: number
  contact: boolean
  number: {
    input: string
    errorMessage: string
  }
  type: {
    input: string
    display: string
    errorMessage: string
  }
}

export const defaultUserPhoneTableItem = (): UserPhoneTableItem => ({
  id: 0,
  contact: false,
  number: {
    input: '',
    errorMessage: ''
  },
  type: {
    input: '',
    display: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    DataTable,
    InputCode
  }
})
export default class UserPhoneTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  inputItems!: UserPhoneTableItem[]

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get halfWidthOnlyMask(): string {
    return MaskPattern.HalfWidthOnly
  }

  get sortedInputItems(): UserPhoneTableItem[] {
    if (this.sortName) {
      return orderBy<UserPhoneTableItem>(
        this.inputItems,
        (item: UserPhoneTableItem) => {
          switch (this.sortName) {
            case 'number':
              return item.number.input
            case 'type':
              return item.type.display
          }
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.inputItems
  }

  get phoneTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.PHONE_TYPE.KEY)
  }

  get allCols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return COLS.map(col => {
        return {
          width: col.width,
          items: col.items.map(item => {
            return {
              name: item.name,
              headerText: item.headerText,
              align: item.align,
              sortable: false,
              sortOrder: item.sortOrder,
              lineFeed: item.lineFeed
            }
          })
        }
      })
    }

    return COLS
  }

  get cols(): Col[] {
    if (this.state.isCreateOrUpdate()) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  @Watch('state.state')
  onChangeState(): void {
    this.onSort({
      name: '',
      order: ''
    })
  }

  add(): void {
    this.inputItems.push({
      ...defaultUserPhoneTableItem(),
      ...{
        contact: this.inputItems.length === 0
      }
    })
  }

  remove(index: number): void {
    const removeRow = () => {
      const isRemoveRowContact = this.inputItems[index].contact

      this.inputItems.splice(index, 1)

      if (this.inputItems.length > 0 && isRemoveRowContact) {
        this.inputItems[0].contact = true
      }
    }

    if (this.inputItems[index].contact) {
      alertStore.setItem(
        AlertFactory.create(AlertCodeALC00007, '予約連絡対象の電話番号', '削除')
      )
      this.$modalAlert.open({
        onOkClick: removeRow
      })
      return
    }

    removeRow()
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onChangeContact(index: number): void {
    this.inputItems.forEach(
      (item: UserPhoneTableItem, arrayIndex: number) =>
        (item.contact = arrayIndex === index)
    )
  }
}
